import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';
import { CustomMonthYearValidator } from 'app/shared/CustomMonthYearValidator';
import RelatorioUtils from 'app/shared/sefaz/relatorio-util';
import { RelatoriosService } from '../relatorios.service';
import DateUtils from 'app/shared/model/date-util';
import { AuthenticationService } from 'app/core/security/authentication-service';

@Component({
  selector: 'app-relatorio-entregas-arquivos',
  templateUrl: './relatorio-entregas-arquivos.component.html',
  styleUrls: ['./relatorio-entregas-arquivos.component.scss']
})
export class RelatorioEntregasArquivosComponent implements OnInit {

    uriEntregaArquivos = '/relatorio_entregas_arquivos.pdf';

    dataInicio: any;
    dataFinal: any;

    periodoInicio = new FormControl('', [Validators.required, CustomMonthYearValidator.dateFormatValidator()]);
    periodoTermino = new FormControl('', [Validators.required, CustomMonthYearValidator.dateFormatValidator()]);

    eventEmitter = new EventEmitter<any>();
    @Output() emitData = new EventEmitter();

    constructor(
        private spinner: NgxSpinnerService,
        public activeModal: NgbActiveModal,
        private service: RelatoriosService,
        private toastr: ToastrService
    ) { }

    ngOnInit(): void {
        this.inicializaPeriodo();
    }

    clear(): void  {
        this.activeModal.dismiss('cancel');
    }

    fecharModal(): void {
        this.activeModal.close();
    }

    public emitirRelatorio(): void {
        try {
            this.validarPeriodos();

            this.spinner.show();
            const parametrosConsulta = this.montarParametrosConsulta();

            this.service.downloadRelatorio(parametrosConsulta, this.uriEntregaArquivos).subscribe(
                (res: any) => {
                    RelatorioUtils.downloadPdf(res, 'entregas-arquivos.pdf')
                        .pipe(
                            finalize((): void => {
                                this.spinner.hide();
                            }),
                            )
                        .subscribe({
                        next: (ret: any) => {
                            this.eventEmitter.emit(ret);
                            this.activeModal.close();
                            this.toastr.success('Relatório gerado com sucesso!', 'Sucesso');
                            this.spinner.hide();
                        },
                        error: (error: any) => {
                            this.toastr.error('Erro ao gerar relatório', "Erro");
                            this.spinner.hide();
                        }
                    });
                },
                (error: any) => {
                    this.toastr.error('Erro durante a geração do relatório', "Erro");
                    this.spinner.hide();
                }
            );
        } catch (error: any) {
            this.toastr.error( error.message, "Erro");
            this.spinner.hide();
        }
    }

    private validarPeriodos(): void {
        if (this.periodoInicio.invalid) {
            throw new Error(this.periodoInicio.errors?.invalidDate);
        }

        if (this.periodoTermino.invalid) {
            throw new Error(this.periodoTermino.errors?.invalidDate);
        }

        if(this.periodoInicio.value !== null && this.periodoTermino.value !== null) {

            const periodoInicioAnoMes: number = DateUtils.converterDeMMAAAAParaAAAAMM(this.periodoInicio.value);
            const periodoTerminoAnoMes: number = DateUtils.converterDeMMAAAAParaAAAAMM(this.periodoTermino.value);

            if (periodoInicioAnoMes > periodoTerminoAnoMes) {
                throw new Error('Período Inicial não pode ser maior que o Final');
            }
        }
    }

    private montarParametrosConsulta(): { periodoInicial: any; periodoFinal: any } {
        return {
            'periodoInicial': this.periodoInicio.value,
            'periodoFinal': this.periodoTermino.value
        };
    }

    private inicializaPeriodo(): void {
        this.periodoInicio.setValue(this.dataInicio);
        this.periodoTermino.setValue(this.dataFinal);
    }

}
